import client from '../apiClient';

const base = '/client-admin/reports';

function qs(params) {
    const p = Object.entries(params).filter(([, v]) => v != null && v !== '');
    return p.length ? `?${new URLSearchParams(p).toString()}` : '';
}

const getDepartments        = ()       => client.get(`${base}/departments`);
const getLearnerPerformance = (p = {}) => client.get(`${base}/learner-performance${qs(p)}`);
const getContentPerformance = (p = {}) => client.get(`${base}/content-performance${qs(p)}`);
const getCertificates       = (p = {}) => client.get(`${base}/certificates${qs(p)}`);
const getLearnerActivity    = (p = {}) => client.get(`${base}/learner-activity${qs(p)}`);

// ─── New: Course & Assessment content tabs ────────────────────────────────────
const getContentList              = ()            => client.get(`${base}/content-list`);
const getContentEnrolledUsers     = (itemId, type) => client.get(`${base}/content-enrolled-users${qs({ itemId, type })}`);
const getAssessmentList           = ()            => client.get(`${base}/assessment-list`);
const getAssessmentEnrolledUsers  = (assessmentIds) => client.get(`${base}/assessment-enrolled-users${qs({ assessmentIds: Array.isArray(assessmentIds) ? assessmentIds.join(',') : assessmentIds })}`);

/** Trigger a browser download for an export */
function exportReport(tab, params = {}) {
    const endpoint = {
        'learner-performance': `${base}/learner-performance`,
        'content-performance': `${base}/content-performance`,
        'certificates':        `${base}/certificates`,
        'learner-activity':    `${base}/learner-activity`,
    }[tab];
    if (!endpoint) return;
    const url = endpoint + qs({ ...params, export: 'xlsx' });
    const apiBase = process.env.REACT_APP_API_ENDPOINT || '';
    window.open(apiBase + url, '_blank');
}

export default {
    getDepartments,
    getLearnerPerformance,
    getContentPerformance,
    getCertificates,
    getLearnerActivity,
    exportReport,
    getContentList,
    getContentEnrolledUsers,
    getAssessmentList,
    getAssessmentEnrolledUsers,
};